import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataFormatService } from '../../../services/data-format.service';
import moment from 'moment';
import { FundParticipantsTable } from './fund-participants-table/fund-participants-table.component';
import { CreditOutletsTable } from './credit-outlets-table/credit-outlets-table.component';
import {DatePipe, formatCurrency} from '@angular/common';
import {MatDialog} from "@angular/material/dialog";
import {AssignmentsModalComponent} from "../../../components/assignments-modal/assignments-modal.component";
import {FundService} from "../../../funds/fund-service.service";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {Apollo} from "apollo-angular";
import {get_credits_by_project} from "../../deals-home/graphql/getProjectDetails";

@Component({
    selector: 'deal-credit-outlets',
    templateUrl: './credit-outlets.component.html',
    styleUrls: ['./credit-outlets.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditOutletsComponent implements OnInit {
  @Input() projectCredits: any;
  @Input() project:any;
  @Input() sequences:any[];
  @Input() fundProjectStates:any[];
  private projectCreditId:string;
  private sponsor:any = null
  private status:any = null

  creditOutlets: any = [];

  constructor(private dataFormat: DataFormatService, private dialog: MatDialog, private datePipe: DatePipe, private fundService: FundService, private _snackBar:MatSnackBar, private apollo: Apollo) {}

  ngOnInit() {
    this.creditOutlets = this.formatCreditOutlets(this.projectCredits);
    this.sponsor = this.project.participants.filter((p:any) => p.sponsor!==null);
    this.status = this.project.projectStatuses.filter((s:any) => s.statusSequence.name=='Syndications');
  }

  formatCreditOutlets(credits: any): any {
    let formatted = [];

    for (let i = 0; i < credits.length; i++) {
      let creditIsWarehouse = credits[i].projectCreditOutlets.length>0 && credits[i].projectCreditOutlets.filter((outlet:any) => outlet.warehoused==true).length > 0
      let creditType =
        credits[i]['taxCreditType']['level'] +
        ' ' +
        credits[i]['taxCreditType']['name'];
      if (credits[i]['taxCreditDesignation']) {
        creditType += ' - ' + credits[i]['taxCreditDesignation']['name'];
      }
      if (
        credits[i]['projectCreditOutlets'] &&
        credits[i]['projectCreditOutlets'].length > 0
      ) {
        for (let j = 0; j < credits[i]['projectCreditOutlets'].length; j++) {
          let hasFund = false;
          let ownershipString =
            credits[i]['projectCreditOutlets'][j]['ownership'].toString();
          let useEquityCalc =
            credits[i]['projectCreditOutlets'][j]['estimated_gross_equity'] ==
              null &&
            credits[i]['projectCreditOutlets'][j]['gross_equity'] == null;
          let certificatedValue = credits[i]['certificated'] ? 1.04 : 1.08;
          let grossEquity = 0.0;
          if (useEquityCalc) {
            grossEquity =
              credits[i]['equity_amount'] *
              credits[i]['projectCreditOutlets'][j]['ownership'] *
              0.01 *
              certificatedValue;
          } else {
            grossEquity =
              credits[i]['projectCreditOutlets'][j][
                'estimated_gross_equity'
              ] !== null
                ? credits[i]['projectCreditOutlets'][j][
                    'estimated_gross_equity'
                  ]
                : credits[i]['gross_equity'];
          }

          if (!ownershipString.includes('.')) {
            ownershipString = ownershipString + '.0000%';
            let places =
              ownershipString.length - 1 - ownershipString.indexOf('.');
          } else {
            let places =
              ownershipString.length - 1 - ownershipString.indexOf('.');
            if (places < 4) {
              for (let i = places; i < 4; i++) {
                ownershipString += '0';
              }
            }
            ownershipString += '%';
          }
          let outletInfo: Array<CreditOutletsTable> = [
            {
              field: 'Placement Status',
              value: credits[i]['projectCreditOutlets'][j]['fundProjectState']
                ? credits[i]['projectCreditOutlets'][j]['fundProjectState'][
                    'name'
                  ]
                : '-',
            },
            { field: '% Ownership', value: ownershipString },
            {
              field: 'Admitted Date',
              value: credits[i]['projectCreditOutlets'][j]['admitted_date']
                ? moment
                    .utc(credits[i]['projectCreditOutlets'][j]['admitted_date'])
                    .format('MM/DD/YYYY')
                : '-',
            },
            {
              field: 'Exit Date',
              value: credits[i]['projectCreditOutlets'][j]['exit_date']
                ? moment
                    .utc(credits[i]['projectCreditOutlets'][j]['exit_date'])
                    .format('MM/DD/YYYY')
                : '-',
            },
            {
              field: 'Total Credits',
              value: formatCurrency(
                credits[i]['amount'],
                'EN',
                '$',
                'USD',
                '1.0-0'
              ),
            },
            {
              field: 'Warehouse',
              value: credits[i]['projectCreditOutlets'][j]['warehoused'] ? 'Yes' : 'No',
            },
            {
              field: 'Price Per Credit',
              value: formatCurrency(
                credits[i]['price'],
                'EN',
                '$',
                'USD',
                '1.4-4'
              ),
            },
            {
              field: 'Gross Equity',
              value: formatCurrency(grossEquity, 'EN', '$', 'USD', '1.0-0'),
            },
          ];

          let outlet = {
            projectCredit: creditType,
            table: outletInfo,
            useGrossEquityCalc: useEquityCalc,
          };

          let formattedIndex = 0;
          if (formatted.length > 0) {
            for (let k = 0; k < formatted.length; k++) {
              if (
                (credits[i]['projectCreditOutlets'][j]['fund'] &&
                  formatted[k].id ===
                    credits[i]['projectCreditOutlets'][j]['fund']['id']) ||
                (credits[i]['projectCreditOutlets'][j]['certificatedOutlet'] &&
                  formatted[k].id ===
                    credits[i]['projectCreditOutlets'][j]['certificatedOutlet'][
                      'id'
                    ])
              ) {
                hasFund = true;
                formattedIndex = k;
                break;
              }
            }

            if (hasFund) {
              formatted[formattedIndex]['outlets'].push(outlet);
            }
          }

          if (formatted.length <= 0 || !hasFund) {
            let participants: Array<FundParticipantsTable> = [];
            if (credits[i]['projectCreditOutlets'][j]['fund']) {
              for (
                let k = 0;
                k <
                credits[i]['projectCreditOutlets'][j]['fund']['participants']
                  .length;
                k++
              ) {
                let role =
                  credits[i]['projectCreditOutlets'][j]['fund']['participants'][
                    k
                  ]['role']['name'];
                if (
                  credits[i]['projectCreditOutlets'][j]['fund']['participants'][
                    k
                  ]['person']
                ) {
                  participants.push({
                    id: credits[i]['projectCreditOutlets'][j]['fund'][
                      'participants'
                    ][k]['person']['id'],
                    name: credits[i]['projectCreditOutlets'][j]['fund'][
                      'participants'
                    ][k]['person']['name'],
                    url: this.dataFormat.formatLink(
                      credits[i]['projectCreditOutlets'][j]['fund'][
                        'participants'
                      ][k]['person']
                    ),
                    role: role,
                  });
                } else {
                  participants.push({
                    id: credits[i]['projectCreditOutlets'][j]['fund'][
                      'participants'
                    ][k]['organization']['id'],
                    name: credits[i]['projectCreditOutlets'][j]['fund'][
                      'participants'
                    ][k]['organization']['name'],
                    url: this.dataFormat.formatLink(
                      credits[i]['projectCreditOutlets'][j]['fund'][
                        'participants'
                      ][k]['organization']
                    ),
                    role: role,
                  });
                }
              }

              if (participants.length > 0) {
                participants.sort(this.compareRole);
              }

              formatted.push({
                id: credits[i]['projectCreditOutlets'][j]['fund']['id'],
                name: credits[i]['projectCreditOutlets'][j]['fund']['name'],
                url: this.dataFormat.formatLink(
                  credits[i]['projectCreditOutlets'][j]['fund']
                ),
                fundType:
                  credits[i]['projectCreditOutlets'][j]['fund']['fundType'][
                    'name'
                  ],
                fundStatus: credits[i]['projectCreditOutlets'][j]['fund']['fundStatuses'].length > 0 ?
                  credits[i]['projectCreditOutlets'][j]['fund'][
                    'fundStatuses'
                  ][0]['status']['name'] : 'N/A',
                closingDate: credits[i]['projectCreditOutlets'][j]['fund'][
                  'close_date'
                ]
                  ? moment
                      .utc(
                        credits[i]['projectCreditOutlets'][j]['fund'][
                          'close_date'
                        ]
                      )
                      .format('MM/DD/YYYY')
                  : null,
                outlets: [outlet],
                participants: participants,
              });
            } else {
              for (
                let k = 0;
                k <
                credits[i]['projectCreditOutlets'][j]['certificatedOutlet'][
                  'participants'
                ].length;
                k++
              ) {
                let role =
                  credits[i]['projectCreditOutlets'][j]['certificatedOutlet'][
                    'participants'
                  ][k]['role']['name'];
                if (
                  credits[i]['projectCreditOutlets'][j]['certificatedOutlet'][
                    'participants'
                  ][k]['person']
                ) {
                  participants.push({
                    id: credits[i]['projectCreditOutlets'][j][
                      'certificatedOutlet'
                    ]['participants'][k]['person']['id'],
                    name: credits[i]['projectCreditOutlets'][j][
                      'certificatedOutlet'
                    ]['participants'][k]['person']['name'],
                    url: this.dataFormat.formatLink(
                      credits[i]['projectCreditOutlets'][j][
                        'certificatedOutlet'
                      ]['participants'][k]['person']
                    ),
                    role: role,
                  });
                } else {
                  participants.push({
                    id: credits[i]['projectCreditOutlets'][j][
                      'certificatedOutlet'
                    ]['participants'][k]['organization']['id'],
                    name: credits[i]['projectCreditOutlets'][j][
                      'certificatedOutlet'
                    ]['participants'][k]['organization']['name'],
                    url: this.dataFormat.formatLink(
                      credits[i]['projectCreditOutlets'][j][
                        'certificatedOutlet'
                      ]['participants'][k]['organization']
                    ),
                    role: role,
                  });
                }
              }

              formatted.push({
                id: credits[i]['projectCreditOutlets'][j]['certificatedOutlet'][
                  'id'
                ],
                name: credits[i]['projectCreditOutlets'][j][
                  'certificatedOutlet'
                ]['organization']['name'],
                url: this.dataFormat.formatLink(
                  credits[i]['projectCreditOutlets'][j]['certificatedOutlet']
                ),
                fundType: null,
                fundStatus: null,
                closingDate: null,
                outlets: [outlet],
              });
            }
          }
        }
      }
    }

    if (formatted.length > 0) {
      //Sort by Fund Name alphabetically first
      formatted.sort(this.compare);

      for (let i = 0; i < formatted.length; i++) {
        let federal = [];
        let state = [];
        for (let j = 0; j < formatted[i].outlets.length; j++) {
          if (formatted[i].outlets[j].projectCredit.includes('Federal')) {
            federal.push(formatted[i].outlets[j]);
          } else {
            state.push(formatted[i].outlets[j]);
          }
        }
        if (federal.length > 0) {
          federal = this.creditSort(federal);
        }

        if (state.length > 0) {
          state = this.creditSort(state);
        }

        formatted[i].outlets = federal.concat(state);
      }
    }
    return formatted;
  }

  compare(a: any, b: any) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  compareRole(a: any, b: any) {
    if (a.role < b.role) {
      return -1;
    }
    if (a.role > b.role) {
      return 1;
    }
    return 0;
  }

  creditSort(credits: any) {
    //Find LIHTC credits and put them at beginning
    //of array
    let lihtc4 = null;
    let lihtc9 = null;
    for (let i = 0; i < credits.length; i++) {
      if (credits[i].projectCredit.includes('LIHTC - 4%')) {
        lihtc4 = i;
      } else if (credits[i].projectCredit.includes('LIHTC - 9%')) {
        lihtc9 = i;
      }
    }
    if (lihtc9) {
      credits = this.array_move(credits, lihtc9, 0);
    }
    if (lihtc4) {
      credits = this.array_move(credits, lihtc4, 0);
    }

    return credits;
  }

  //this is to move objects within an array
  array_move(arr: any, old_index: number, new_index: number) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  public openAssignmentsModal(){
    let closingPipeline = this.project.pipelineProjects[0].pipelineProjectDates.filter((date:any) => date.pipelineMilestone.milestone.name == 'Closed')
    let dialogRef = this.dialog.open(AssignmentsModalComponent, {
      width: "1200px",
      data: {
        //projectCreditId: row.credit_id,
        projectId: this.project.id,
        project: this.project.name,
        status: this.status[0]?.status.name,
        projecturl: this.dataFormat.formatLink(this.project),
        sponsor: this.sponsor[0]?.sponsor?.name,
        closing_date: closingPipeline?.length ? closingPipeline[0].date : null,
        sponsorurl: this.dataFormat.formatLink(this.sponsor[0]?.sponsor),
        fundProjectStates: this.fundProjectStates,
        sequenceStatuses: this.sequences,
        type: 'Fund'
      }
    })
    let componentInstance = dialogRef.componentInstance.onSave.subscribe((data:any) => {
      let keys = Object.keys(data);
      let outlets:any[] = []
      for(let i = 0; i < keys.length; i++){
        outlets.push(...data[keys[i]]);
      }
      let outletData:any[] = []
      for(let i = 0; i < outlets.length; i++){
        if(outlets[i]){
          let outletObj = {
            ut_irr: outlets[i].value.ut_irr,
            revenue_year: outlets[i].value.revenue_year,
            ownership: outlets[i].value.ownership,
            credit_id: outlets[i].value.credit_id,
            outlet_id: outlets[i].value.outlet_id,
            equity_amount: outlets[i].value.gross_equity,
            estimated_gross_equity: outlets[i].value.estimated_gross_equity,
            load_percentage: outlets[i].value.load,
            admitted_date: this.datePipe.transform(outlets[i].value.admitted_date),
            is_target_exit: outlets[i].value.is_target_exit,
            is_target: outlets[i].value.is_target,
            exit_date: outlets[i].value.exit_date,
            fund_project_state_id: outlets[i].value.placement_status,
            fund_id: outlets[i].value.fund_id,
            certificated_outlet_id: outlets[i].value.certificated_outlet_id,
            warehoused: outlets[i].value.warehoused,
            investor_approval_date: outlets[i].value.investor_approval_date,
            projected_warehouse_days: outlets[i].value.projected_warehouse_days,
            is_target_investor_approval: outlets[i].value.is_target_investor_approval
          }
          outletData.push(outletObj)
        }
      }

      if(outletData!==null && outletData.length!==0){
        let savedOutlet = 0;
        outletData.forEach((outlet:any)=> {

          if(outlet.outlet_id!==null){
            this.fundService.updateProjectCredit(outlet, (response:any) => {
              savedOutlet += 1;
              if(savedOutlet == outletData.length){
                this.openSnackBar('Credits saved', 'save-success')
                this._refreshCredits()
                dialogRef.close();
              }
              }
            )
          } else {
            let outletVar = {
              project_credit_id: outlet.credit_id,
              fund_id: outlet.fund_id,
              certificated_outlet_id: outlet.certificated_outlet_id,
              fund_project_state_id: outlet.fund_project_state_id,
              ownership: outlet.ownership,
              estimated_gross_equity: outlet.estimated_gross_equity,
              gross_equity: null,
              purchase_amount: null,
              admitted_date: outlet.admitted_date !== null ? this.datePipe.transform(outlet.admitted_date, 'yyyy-MM-dd') : null,
              exit_date: outlet.exit_date !== null ? this.datePipe.transform(outlet.exit_date, 'yyyy-MM-dd') : null,
              is_target: outlet.is_target ?? false,
              is_target_exit: outlet.is_target_exit ?? false,
              revenue_year: outlet.revenue_year,
              warehoused: outlet.warehoused,
              is_target_investor_approval: outlet.is_target_investor_approval,
              investor_approval_date: outlet.investor_approval_date !== null ? this.datePipe.transform(outlet.investor_approval_date, 'yyyy-MM-dd') : null,
              projected_warehouse_days: outlet.projected_warehouse_days,
              is_revenue_flagged: false,
              load_percentage: outlet.load_percentage,
              ut_irr: outlet.ut_irr
            }
            this.fundService.createProjectCreditOutlet(outletVar, (response:any) => {
              savedOutlet += 1;
              if(savedOutlet == outletData.length){
                this.openSnackBar('Credits saved', 'save-success')
                this._refreshCredits()
                dialogRef.close();
              }
            })
          }
        })
      }

    })

    let removeInstance = dialogRef.componentInstance.onRemove.subscribe((data:string) => {
      this.fundService.deleteProjectCredit(data, (response:any) => {
        this.openSnackBar('Credit outlet removed', 'save-success')
        setTimeout(() => {
          this._refreshCredits()

        }, 2000)
      });
    })

    let subscribeInstance = dialogRef.componentInstance.onSubscribe.subscribe((data:any) => {
      setTimeout(() => {
        this._refreshCredits()

      }, 2000)
    })
  }

  private _refreshCredits(){
    this.apollo.watchQuery({
      query: get_credits_by_project,
      fetchPolicy: 'no-cache',
      variables: {
        id: this.project.id
      }
    }).valueChanges.subscribe((data:any) => {
      this.projectCredits = data.data.project.projectCredits
      this.creditOutlets = this.formatCreditOutlets(this.projectCredits)
      this.status = data.data.project.projectStatuses.filter((s:any) => s.statusSequence.name=='Syndications');
    })
  }

  private openSnackBar(message: string, panel_class:string) {
    const config = new MatSnackBarConfig();
    config.panelClass = panel_class !== null ? [panel_class] : ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }
}
